var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.numberOfPages),function(i){return _c('pdf',{key:i,class:_vm.useAsComponent ? '' : 'pdfViewer',attrs:{"src":_vm.pdfSrc,"page":i}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }